// extracted by mini-css-extract-plugin
var _1 = "OCpUh";
var _2 = "B5HXj";
export { _1 as "body", _2 as "modalActions" }
